require("core-js/modules/es.array.reduce.js");

var _toConsumableArray = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/toConsumableArray");

module.exports = parseRange;
module.exports.parse = parseRange;
module.exports.compose = composeRange;

function composeRange(range) {
  return range.reduce(function (acc, cur, idx, arr) {
    if (idx === 0 || cur !== arr[idx - 1] + 1) acc.push([]);
    acc[acc.length - 1].push(cur);
    return acc;
  }, []).map(function (cur) {
    return cur.length > 1 ? "".concat(cur[0], "-").concat(cur[cur.length - 1]) : "".concat(cur[0]);
  });
}

function parseRange(range) {
  var generateRange = function generateRange(start) {
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start;
    return Array.from({
      length: end - start + 1
    }, function (cur, idx) {
      return idx + start;
    });
  };

  return range.reduce(function (acc, cur, idx, arr) {
    var r = cur.split('-').map(function (cur) {
      return parseInt(cur);
    });
    return acc.concat(generateRange.apply(void 0, _toConsumableArray(r)));
  }, []);
}